var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3636_85452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.712727 6.14015C1.68661 3.72667 3.57937 1.79891 5.9746 0.780955C8.36983 -0.236995 11.0713 -0.261749 13.4848 0.712137C15.8983 1.68602 17.8261 3.57878 18.844 5.97401C19.862 8.36924 19.8867 11.0708 18.9128 13.4842C17.939 15.8977 16.0462 17.8255 13.651 18.8434C11.2557 19.8614 8.55423 19.8861 6.14074 18.9123C3.72726 17.9384 1.7995 16.0456 0.781545 13.6504C-0.236405 11.2551 -0.26116 8.55364 0.712727 6.14015ZM6.5613 2.16146C4.5322 3.0238 2.92877 4.65689 2.10375 6.70145C1.27873 8.74602 1.2997 11.0346 2.16205 13.0637C3.02439 15.0928 4.65748 16.6962 6.70204 17.5212C8.74661 18.3463 11.0352 18.3253 13.0643 17.4629C15.0934 16.6006 16.6968 14.9675 17.5218 12.9229C18.3468 10.8784 18.3259 8.58981 17.4635 6.56071C16.6012 4.53161 14.9681 2.92818 12.9235 2.10316C10.879 1.27814 8.5904 1.29911 6.5613 2.16146Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6904 15.6898C15.9833 15.397 16.4582 15.397 16.7511 15.6899L23.7801 22.7199C24.0729 23.0128 24.0729 23.4877 23.78 23.7806C23.4871 24.0735 23.0122 24.0734 22.7193 23.7805L15.6903 16.7505C15.3975 16.4576 15.3975 15.9827 15.6904 15.6898Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3636_85452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search.b5c03fef26be756387d86d541691b9e3.svg";